import { configureStore } from '@reduxjs/toolkit'
import authReducer from './features/authSlice'
import serviceOrdersReducer from './features/serviceOrdersSlice'
import whatsappReducer from './features/whatsappSlice'
import dashboardReducer from './features/dashboardSlice'
import tutorialsReducer from './features/tutorialsSlice'
import transmissionListsReducer from './features/transmissionListsSlice'
import delayedJourneyStagesCacheReducer from './features/delayedJourneyStagesCacheSlice'
import conversationsReducer from './features/conversationsSlice'
import conversationMessagesReducer from './features/conversationMessagesSlice'
import internalConversationsReducer from './features/internalConversationsSlice'
import clientsReducer from './features/clientsSlice'
import drawerReducer from './features/drawerSlice'
import quickMessagesReducer from './features/quickMessagesSlice'
import tasksReducer from './features/tasksSlice'
import notificationsReducer from './features/notificationsSlice'
import contactDirectoryReducer, {
  persistContactDirectoryCache,
} from './features/contactDirectorySlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    serviceOrders: serviceOrdersReducer,
    whatsapp: whatsappReducer,
    delayedJourneyStagesCache: delayedJourneyStagesCacheReducer,
    dashboard: dashboardReducer,
    tutorials: tutorialsReducer,
    transmissionLists: transmissionListsReducer,
    conversations: conversationsReducer,
    conversationMessages: conversationMessagesReducer,
    internalConversations: internalConversationsReducer,
    quickMessages: quickMessagesReducer,
    clients: clientsReducer,
    drawer: drawerReducer,
    tasks: tasksReducer,
    notifications: notificationsReducer,
    contactDirectory: contactDirectoryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

let previousContactDirectory = store.getState().contactDirectory
store.subscribe(() => {
  const contactDirectory = store.getState().contactDirectory
  if (contactDirectory === previousContactDirectory) return
  previousContactDirectory = contactDirectory
  persistContactDirectoryCache(contactDirectory)
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
